import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchApi,
  makeResetCache,
  notifyError,
  notifyResponse,
  RecordPicker,
  useCacheRecord,
} from 'gossamer-front-end';
import {
  AdminInstitutionGroupMemberAddRequest,
  InstitutionGroupMember,
  InstitutionGroupMemberView,
  UserView,
} from 'cb-model';
import { InputGroup } from 'react-bootstrap';
import { FieldType } from 'gossamer-unified';

export interface AddMemberToGroupButtonProps {
  institutionGroupId: number;
  institutionId: number;
}

export const AddMemberToGroupButton: React.FC<AddMemberToGroupButtonProps> = (props): React.JSX.Element => {
  const [userId, setUserId] = React.useState<string | null>(null);
  return (
    <InputGroup>
      <InputGroup.Text>Add an existing Member to this Group</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={setUserId}
        value={userId}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'Member',
          refEntity: UserView,
        }}
      />
      {userId && <Execute {...props} setUserId={setUserId} userId={userId} />}
    </InputGroup>
  );
};

interface ExecuteProps {
  institutionId: number;
  institutionGroupId: number;
  setUserId: (newUserId: string) => void;
  userId: string;
}

const Execute = (props: ExecuteProps): React.JSX.Element => {
  const userRecord = useCacheRecord(UserView, props.userId);
  const isProcessing = React.useRef(false);
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const exec = async () => {
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const response = await fetchApi('POST', `/main/institution-group-member-add`, {
        invites: [{ emailAddress: userRecord.data?.email, addToInstitutionGroupIds: [props.institutionGroupId] }],
        institutionId: props.institutionId,
      } as AdminInstitutionGroupMemberAddRequest);
      resetCache(UserView.id, props.userId);
      resetCache(InstitutionGroupMember.id);
      resetCache(InstitutionGroupMemberView.id);
      props.setUserId(null);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while adding the member to the group');
    }
    isProcessing.current = false;
  };
  React.useEffect(() => {
    if (userRecord.data) {
      exec();
    }
  }, [userRecord.data]);
  return null;
};
